import React from 'react';
/** Error component for displaying (not only) filters errors*/
export const ErrorJumbotron = props => <div className="jumbotron jumbotron-fluid">
    <div className="container">
        <p className="lead text-center">{props.message}</p>
    </div>
</div>